import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { matchPath, useLocation, useParams } from 'react-router-dom';
import find from 'lodash/find';

import { PageName, RsRoute } from '@Pages/RetroSynthesis/routes';

import ProjectRouteToolbar from './ProjectRouteToolbar';

export const pagePathNameMapper = {
  [RsRoute.PROJECT_ROUTE_TREE_VIEW]: PageName.TREE_VIEW,
};

export const getPageNameByPath = (pathname) => {
  return find(pagePathNameMapper, (name, path) => !!matchPath(pathname, { path }));
};
/* eslint-disable react/prop-types */
/* eslint-disable no-shadow */
export function ProjectRouteToolbarContainer({ conditionsIsShown, setConditionsIsShown, onExport, routeType }) {
  const { projectId, routeId } = useParams();
  const location = useLocation();
  const [pageName, setPageName] = useState(getPageNameByPath(location.pathname));

  useEffect(() => {
    setPageName(getPageNameByPath(location.pathname));
  }, [location]);

  return (
    <ProjectRouteToolbar
      projectId={projectId}
      routeId={routeId}
      pageName={pageName}
      conditionsIsShown={conditionsIsShown}
      setConditionsIsShown={setConditionsIsShown}
      onExport={onExport}
      routeType={routeType}
    />
  );
}

ProjectRouteToolbarContainer.defaultProps = {
  onExport: () => null,
};

ProjectRouteToolbarContainer.propTypes = {
  onExport: PropTypes.func,
  routeType: PropTypes.string,
};

export default ProjectRouteToolbarContainer;
